import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, setConfigTableModalBusqueda } from 'src/app/shared/utils';
import { alertaConfirmacion, alertaConfirmacionHTML, basicAlert, basicAlertHTML, filtrarCoincidenciaArrayTransportista, obtenerFechaActual, obtenerFechaSeleccionada, openDescripcion, openObservacion, openReutilizar, setConfigTableBuscador, timerOut, validarCodigoExistentesComercial } from 'src/app/shared/utils';
import { ConsultaCotizacionService } from 'src/app/services/comercial-consulta-cotizacion.service';
import { StorageService } from 'src/app/services/storage.service';
import { OrdenpedidoService } from 'src/app/services/ordenpedido.service';
import { GuiaremisionService } from 'src/app/services/guiaremision.service';
import { FacturaService } from 'src/app/services/factura.service';
import { CotizacionService } from 'src/app/services/cotizacion.service';
import { BoletaService } from 'src/app/services/boleta.service';
import { GuiaInternaService } from 'src/app/services/GuiaInterna.service'
import { GuiarecepcionService } from 'src/app/services/guiarecepcion.service'
import { DocImportacionService } from 'src/app/services/DocImportacion.service';
import { OrdCompraService } from 'src/app/services/OrdCompra.service';
import { ReqCompraService } from 'src/app/services/ReqCompra.service';
import { ConsultaService } from 'src/app/services/consulta.service';
import { DocumentoCabeceraService } from 'src/app/services/documento-cabecera.service';

@Component({
  selector: 'app-trazabilidad',
  templateUrl: './trazabilidad.component.html',
  styleUrls: ['./trazabilidad.component.css']
})
export class TrazabilidadComponent implements OnInit {

  @Input() trazabilidades: [];
  public logTranzacciones: any[] = [];
  public datosAdjuntos: any[] = [];

  dtTrigger: Subject<null> = new Subject();
  dtOptions: any = {};


  public numintDoc: number = null;
  public tipdoc: number = null;
  public series: string = '';
  public numdoc: number = null;
  public viewTrazabilidad: boolean = true;
  public viewDatosAdjuntos: boolean = false;
  public viewLogTrazabilidad: boolean = false;

  public sessionInfo: any = {};

  public docSeleccionado: any = null;

  public tabseleccionado = false;
  constructor(
    private trazabilidadService: ConsultaService,
    private modalService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private ConsultaCotizacionService: ConsultaCotizacionService,
    private ordenPedidoService: OrdenpedidoService,
    private gremisionService: GuiaremisionService,
    private facturaService: FacturaService,
    private boletaService: BoletaService,
    private cotizacionService: CotizacionService,
    private GuiaInternaService: GuiaInternaService,
    private GuiarecepcionService: GuiarecepcionService,
    private DocImportacionService: DocImportacionService,
    private ordCompraService: OrdCompraService,
    private reqCompraService: ReqCompraService,
    private docCabService: DocumentoCabeceraService,

  ) { }

  ngOnInit(): void {
    this.dtOptions = setConfigTableBuscador(true)
    this.sessionInfo = JSON.parse(StorageService.getSession());

  }

  onChangeNextFocus(idFocus: string) {

  }

  onSelectItem(data: any) {
    this.viewTrazabilidad = false
    this.docSeleccionado = data;

    this.numintDoc = data.numint;
    this.tipdoc = data.tipdoc;
    this.series = data.series;
    this.numdoc = data.numdoc;

    this.onClickDatosAdjunto();
    this.onClickLogTransaccion();
    this.tabseleccionado = true;
  }

  clickTabTrazabilidad() {

    console.log("click en el tab Trazabilida")
    console.log(this.docSeleccionado)
  }

  onClickTrazabilidad(data: any) {
    this.numintDoc = data.numint;
    this.tipdoc = data.tipdoc;
    this.series = data.series;
    this.numdoc = data.numdoc;
    this.viewTrazabilidad = false;
    this.viewDatosAdjuntos = true;
    this.viewLogTrazabilidad = true;
    //
    this.onClickDatosAdjunto();
    this.onClickLogTransaccion();
  }

  returnTrazabilidad() {
    this.viewTrazabilidad = true;
    this.viewDatosAdjuntos = false;
    this.viewLogTrazabilidad = false;
  }

  cerrar() {
    //$('.nav-tabs a[href="#' + 'tabmodal_1' + '"]').tab('show');
    this.viewTrazabilidad = true;
    this.viewDatosAdjuntos = false;
    this.viewLogTrazabilidad = false;
    this.trazabilidades = [];
    this.datosAdjuntos = [];
    this.logTranzacciones = [];
    this.numintDoc = null;
    this.tipdoc = null;
    this.series = '';
    this.numdoc = null;
    this.modalService.dismiss('canceling');
    this.dtTrigger.unsubscribe();
  }

  Restaurar() {
    this.tabseleccionado = false;
    this.viewTrazabilidad = true;
    this.trazabilidades = [];
    this.datosAdjuntos = [];
    this.logTranzacciones = [];
    this.numintDoc = null;
    this.tipdoc = null;
    this.series = '';
    this.numdoc = null;
  }

  onClickDatosAdjunto() {
    console.log('numunt')
    console.log(this.numintDoc)
    console.log(this.docSeleccionado)

    //this.spinnerService.activarLoading(true);
    //this.FuncionesTSI.destroyTable('ModalDatatableDatosAdjuntos');
    this.trazabilidadService.getArchivosAdjuntos(this.numintDoc).subscribe((response: any) => {
      console.log("datos adjuntos")
      console.log(response)
      //if (response.status == 1.0) {
      this.datosAdjuntos = response.body;
      //this.chRef.detectChanges();
      //this.FuncionesTSI.createTable('ModalDatatableDatosAdjuntos', false, true, '274px');
      //} else {
      //  this.FuncionesTSI.alertSweet('Servicio no disponible', 'warning');
      //}
      // this.spinnerService.activarLoading(false);
    })
  }

  onClickLogTransaccion() {
    //this.spinnerService.activarLoading(true);
    //this.FuncionesTSI.destroyTable('ModalDatatableLogTransacciones');
    this.trazabilidadService.getListTransaccionLogDocumentos(this.numintDoc).subscribe((response: any) => {
      console.log("Log Documentos")
      console.log(response)
      //if (response.status == 1.0) {
      this.logTranzacciones = response.body.list;
      //  this.chRef.detectChanges();
      //  this.FuncionesTSI.createTable('ModalDatatableLogTransacciones', false, true, '274px');
      //} else {
      //  this.FuncionesTSI.alertSweet('Servicio no disponible', 'warning');
      //}
      // this.spinnerService.activarLoading(false);
    });

  }

  downloadPDFReporte(data: any, formato?: string) {

    //COTIZACION
    if (data.tipdoc == 100) {

      if (formato == 'A4SinDescuento') {
        this.spinnerService.activarLoading(true);
        this.ConsultaCotizacionService.downloadCotizacionFormato1(data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

      if (formato == 'A4ConDescuento') {
        this.spinnerService.activarLoading(true);
        this.ConsultaCotizacionService.downloadCotizacionFormato2(data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

      if (formato == 'TICKET') {
        this.spinnerService.activarLoading(true);
        this.ConsultaCotizacionService.downloadCotizacionFormatoTicket(data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

    }
    //ORDEN DE PEDIDO
    if (data.tipdoc == 101) {
      this.spinnerService.activarLoading(true);
      this.ordenPedidoService.download_pdf(1, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        console.log(response);
        if (response.byteLength > 0) {
          let file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
        }
      }, err => {
        console.log(err)
        this.spinnerService.activarLoading(false);
        basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
      });
    }

    //GUIA DE REMISON
    if (data.tipdoc == 102) {

      if (formato == 'A4') {
        console.log("SI esta enbtrando al metodo impresion A4")
        this.spinnerService.activarLoading(true);
        this.gremisionService.descargarPDF(data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      } else if (formato == 'TICKET') {
        console.log("SI esta enbtrando al metodo impresion TICKET")
        this.spinnerService.activarLoading(true);
        this.gremisionService.descargarTicket(data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response != null && response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('Servicio de impresión no disponible.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }
    }

    //FACTURA
    if (data.tipdoc == 1) {
      if (formato == 'TICKET') {

        this.spinnerService.activarLoading(true);
        this.facturaService.download_pdf(2, data.numint, this.sessionInfo.cia).subscribe(((response: any) => {
          this.spinnerService.activarLoading(false);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('Servicio de impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
          }
        }), err => {
          this.spinnerService.activarLoading(false);
          basicAlert('Servicio de impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        })
      }

      if (formato == 'A4') {
        this.spinnerService.activarLoading(true);
        this.facturaService.download_pdf(3, data.numint, this.sessionInfo.cia).subscribe(((response: any) => {
          this.spinnerService.activarLoading(false);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('Servicio de impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
          }
        }), err => {
          this.spinnerService.activarLoading(false);
          basicAlert('Servicio de impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);

        })
      }

    }

    //BOLETAS
    if (data.tipdoc == 3) {
      if (formato == 'TICKET') {
        this.spinnerService.activarLoading(true);
        this.boletaService.download_pdf(2, data.numint, this.sessionInfo.cia).subscribe(((response: any) => {
          this.spinnerService.activarLoading(false);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('Servicio de impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
          }
        }), err => {
          this.spinnerService.activarLoading(false);
          basicAlert('Servicio de impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);

        })
      }

      if (formato == 'A4') {
        this.spinnerService.activarLoading(true);
        this.boletaService.download_pdf(3, data.numint, this.sessionInfo.cia).subscribe(((response: any) => {
          this.spinnerService.activarLoading(false);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('Servicio de impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
          }
        }), err => {
          this.spinnerService.activarLoading(false);
          basicAlert('Servicio de impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);

        })
      }

    }

    //GUIAS INTERNAS
    if (data.tipdoc == 103) {
      console.log(formato)
      if (formato == 'A4CalidadColor') {
        console.log("con calidada")
        this.spinnerService.activarLoading(true);
        this.GuiaInternaService.download_pdf(2, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

      if (formato == 'A4') {
        this.spinnerService.activarLoading(true);
        this.GuiaInternaService.download_pdf(1, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

    }

    //REQUERIMIENTO DE COMPRA

    if (data.tipdoc == 125) {
      console.log(formato)
      if (formato == 'A4CalidadColor') {
        console.log("con calidada")
        this.spinnerService.activarLoading(true);
        this.reqCompraService.download_pdf(2, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

      if (formato == 'A4') {
        this.spinnerService.activarLoading(true);
        this.reqCompraService.download_pdf(1, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

    }

    //ORDEN DE COMPRA

    if (data.tipdoc == 105) {
      console.log(formato)
      if (formato == 'A4CalidadColor') {
        console.log("con calidada")
        this.spinnerService.activarLoading(true);
        this.ordCompraService.download_pdf(2, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

      if (formato == 'A4') {
        this.spinnerService.activarLoading(true);
        this.ordCompraService.download_pdf(1, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

    }

    //DOCUMENTOS DE IMPROTACION

    if (data.tipdoc == 115) {
      console.log(formato)
      if (formato == 'A4CalidadColor') {
        console.log("con calidada")
        this.spinnerService.activarLoading(true);
        this.DocImportacionService.download_pdf(2, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

      if (formato == 'A4') {
        this.spinnerService.activarLoading(true);
        this.DocImportacionService.download_pdf(1, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

    }


    //GUIA DE RECEPCION

    if (data.tipdoc == 108) {
      console.log(formato)

      if (formato == 'Imprimir') {
        this.spinnerService.activarLoading(true);
        this.GuiarecepcionService.descargarPDF(data.numint).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
      }

    }
   
       //NOTA DE CREDITO
       if (data.tipdoc == 7) {
        this.spinnerService.activarLoading(true);
        this.docCabService.download_pdf(7,this.sessionInfo.id_cia,data.numint).subscribe(((resp: any) => {
          this.spinnerService.activarLoading(false);
          if (resp.byteLength > 0) {
            let file = new Blob([resp], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('Archivo no disponible..', 'warning', 'Aceptar', null, null, null);
          }
        }), err => {
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
  
        })
      }

    /*
       //CHEQUE DEVUELTO
       if (data.tipdoc == 4) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
   
       //LETRAS
       if (data.tipdoc == 5) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
       //CHEQUE COB.FUTURA
       if (data.tipdoc == 6) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
   
       //NOTA DE CREDITO
       if (data.tipdoc == 7) {
         this.notaCreditoService.downloadPdfNotaCreditoA4(data.numint).subscribe((response: any) => {
           if (response != null) {
             if (response.byteLength > 0) {
               this.downloadPdf(response, data);
             }
           }
           else {
             this.FuncionesTSI.activarLoading(false);
             this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
           }
         }, err => {
           if (err.status == 404) {
             console.log(err);
             this.FuncionesTSI.activarLoading(false);
             this.FuncionesTSI.alertSweet('No hay resultados', 'error');
           }
         })
       }
   
       //NOTA DE DEBITO
       if (data.tipdoc == 8) {
         this.notaDebitoService.downloadPdfNotaDebitoA4(data.numint).subscribe((response: any) => {
           if (response != null) {
             if (response.byteLength > 0) {
               this.downloadPdf(response, data);
             }
           }
           else {
             this.FuncionesTSI.activarLoading(false);
             this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
           }
         }, err => {
           console.log(err);
           if (err.status == 404) {
             this.FuncionesTSI.alertSweet('No hay resultados', 'error');
           }
           this.FuncionesTSI.activarLoading(false);
         })
       }
   
   
       //ANTICIPO
       if (data.tipdoc == 9) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
   
   
       //TICKET DE MAQUINA
       if (data.tipdoc == 12) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
   
       //PERCEPCION FUTURA
       if (data.tipdoc == 12) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
   
       //COMPRO PRECEPCIO
       if (data.tipdoc == 41) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
       //DEPOSITO NO IDENTIFI
       if (data.tipdoc == 43) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
       //DOCUMENTO BALON
       if (data.tipdoc == 44) {
         this.FuncionesTSI.activarLoading(false);
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
       }
   
       //COTIZACION
       if (data.tipdoc == 100) {
         if (formato == 'A4SinDescuento') {
           this.cotizacionServices.downloadPdfCotizacionA4SinDescuento(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           })
         }
   
         if (formato == 'A4ConDescuento') {
           this.cotizacionServices.downloadPdfCotizacionA4ConDescuento(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           })
         }
   
         if (formato == 'TICKET') {
           this.cotizacionServices.downloadPdfCotizacionTicket(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           })
         }
   
       }
   
       //ORDEN DE PEDIDO
       if (data.tipdoc == 101) {
         this.trazabilidadService.getdownloadPDFreporteTrazabilidadOrdenPedido(data.numint, this.rucEmpresa).subscribe((response: any) => {
           if (response != null) {
             if (response.byteLength > 0) {
               this.downloadPdf(response, data);
             }
           } else {
             this.FuncionesTSI.activarLoading(false);
             this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
           }
         }, err => {
           if (err.status == 404) {
             console.log(err);
             this.FuncionesTSI.activarLoading(false);
             this.FuncionesTSI.alertSweet('No hay resultados', 'error');
           }
         })
       }
   
   
       //GUIA DE REMISON
       if (data.tipdoc == 102) {
         if (formato == 'A4') {
           this.GuiaRemisionService.downloadPdfGuiaRemisionA4(data.numint)
             .subscribe((response: any) => {
               this.FuncionesTSI.activarLoading(false);
               if (response != null) {
                 if (response.byteLength > 0) {
                   this.downloadPdf(response, data);
                 }
               }
               else {
                 this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
               }
   
             }, err => {
               this.FuncionesTSI.activarLoading(false);
               console.log(err);
               if (err.status == 404) {
                 this.FuncionesTSI.alertSweet('No hay resultados', 'error');
               }
              
             })
         }
   
         if (formato == 'TICKET') {
           this.GuiaRemisionService.downloadPdfGuiaRemisionTicket(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
   
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           })
         }
       }
   
   
   
       //GUIA RECEPCION
       if (data.tipdoc == 108) {
         this.trazabilidadService.dowloadPdfComprobanteVentaTrazabilidadGuiaRecepcion(data.numint, this.rucEmpresa).subscribe((response: any) => {
           if (response != null) {
             if (response.byteLength > 0) {
               this.downloadPdf(response, data);
             }
           }
           else {
             this.FuncionesTSI.activarLoading(false);
             this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
           }
         })
       }
   
       //RECIBO
       if (data.tipdoc == 210) {
         this.reciboService.dowloadPdfComprobanteVentaReciboTicket(data.numint).subscribe((response: any) => {
           if (response != null) {
             if (response.byteLength > 0) {
               this.downloadPdf(response, data);
             }
           }
           else {
             this.FuncionesTSI.activarLoading(false);
             this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
           }
         }, err => {
           if (err.status == 404) {
             console.log(err);
             this.FuncionesTSI.activarLoading(false);
             this.FuncionesTSI.alertSweet('No hay resultados', 'error');
           }
         })
       }
   
       if (data.tipdoc == 103) {
         if (formato == 'A4') {
           this.guiasInternasService.downloadPdfGuiaInternaA4(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           });
         }
   
         if (formato == 'A4CodigosAdicionaes') {
           this.guiasInternasService.downloadPdfGuiaInternaA4CodigosAdicionales(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           });
         }
       }
   
       if (data.tipdoc == 125) {
         if (formato == 'A4') {
           this.requerimientoService.downloadPdfRequerimientoCompraNormalA4(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           });
         }
   
         if (formato == 'A4CodigosAdicionaes') {
           this.requerimientoService.downloadPdfRequerimientoCompraCodAddA4(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           });
         }
       }
   
       if (data.tipdoc == 105) {
         if (formato == 'A4') {
           this.ordenCompraService.downloadPdfOrdenCompraNormalA4(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           });
         }
   
         if (formato == 'A4CodigosAdicionaes') {
           this.ordenCompraService.downloadPdfOrdenCompraCodAddA4(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           });
         }
       }
   
       if (data.tipdoc == 115) {
         if (formato == 'A4') {
           this.documentoImportacionService.downloadPdfDocumentoImportacionNormalA4(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           });
         }
   
         if (formato == 'A4CodigosAdicionaes') {
           this.documentoImportacionService.downloadPdfDocumentoImportacionCodAddA4(data.numint).subscribe((response: any) => {
             if (response != null) {
               if (response.byteLength > 0) {
                 this.downloadPdf(response, data);
               }
             }
             else {
               this.FuncionesTSI.activarLoading(false);
               this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
             }
           }, err => {
             console.log(err);
             if (err.status == 404) {
               this.FuncionesTSI.alertSweet('No hay resultados', 'error');
             }
             this.FuncionesTSI.activarLoading(false);
           });
         }
       }
       */
  }

  downloadPDFFormato1(data: any) {
    this.spinnerService.activarLoading(true);
    this.ordenPedidoService.download_pdf(1, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });
  }

  downloadPDFFormato2(data: any) {
    this.spinnerService.activarLoading(true);
    this.ordenPedidoService.download_pdf(2, data.numint, this.sessionInfo.cia).subscribe((response: any) => {
      console.log(response);
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err.error)
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });

  }
  
  routerEstadoCuenta(codcli: string) {
    //this.router.navigateByUrl(`/cuentas-cobrar/consultas/estado-cuenta/${codcli}`);
    //$('.js-sidebar-toggler').click();
  }

  downloadDatosAdjuntos(data: any) {
    /* this.FuncionesTSI.activarLoading(true);
     this.archivosAdjuntosService.getdownloadArchivosAdjuntos(data.numint, data.item).subscribe((response: any) => {
 
       if (response.byteLength > 0) {
         this.FuncionesTSI.activarLoading(false);
         let file = new Blob([response]);
         var fileURL = URL.createObjectURL(file);
         FileSaver.saveAs(fileURL, data.nombre);
       } else {
         this.FuncionesTSI.alertSweet('No hay resultados', 'warning');
         this.FuncionesTSI.activarLoading(false);
       }
     })
     */
  }


}
